import { Injectable } from '@angular/core';
import { SidebarNavigationItem } from '../models/sidebar-navigation-item.model';

@Injectable({
  providedIn: 'root',
})
export class SidebarNavigationService {
  private readonly primaryItems: SidebarNavigationItem[] = [
    { icon: 'home', label: 'Home', route: '/home' },
    { icon: 'garage', label: 'Taxizentralen', route: '/taxiCenter' },
    { icon: 'bus', label: 'Busse', route: '/bus' },
    { icon: 'worker', label: 'Taxifahrer', route: '/taxiDriver' },
    { icon: 'group', label: 'Fahrgäste', route: '/passenger' },
    { icon: 'taxiAttendant', label: 'Begleitpersonen', route: '/taxiAttendant' },
    { icon: 'phone', label: 'Fahrgast Accounts', route: '/appAccounts' },
    { icon: 'route', label: 'Transportaufträge', route: '/trip' },
    { icon: 'taxitriptour', label: 'Fahrten', route: '/triptour' },
    { icon: 'contacts', label: 'Adressbuch', route: '/contacts' },
    { icon: 'clock', label: 'MA Zeiterfassung', route: '/driverStats' },
    { icon: 'clock', label: 'BP Zeiterfassung', route: '/attendantStats' },
    { icon: 'clock', label: 'Fahrgast Statistik', route: '/passengerStats' },
    { icon: 'map', label: 'Live Karte', route: '/live-map' },
  ];

  private readonly secondaryItems: SidebarNavigationItem[] = [
    { icon: 'account_c', label: 'Profil', route: '/profile' },
  ];

  private readonly createItems: SidebarNavigationItem[] = [
    {
      icon: 'route',
      label: 'Transportauftrag anlegen',
      route: '/trip/addTrip',
      aliases: ['neuen Transportauftrag'],
      isCreate: true,
    },
    {
      icon: 'bus',
      label: 'Bus anlegen',
      route: '/bus/editBus',
      isCreate: true,
    },
    {
      icon: 'garage',
      label: 'Taxizentrale anlegen',
      route: '/taxiCenter/editTaxiCenter',
      isCreate: true,
    },
    {
      icon: 'worker',
      label: 'Taxifahrer anlegen',
      route: '/taxiDriver/editTaxiDriver',
      isCreate: true,
    },
    {
      icon: 'group',
      label: 'Fahrgast anlegen',
      route: '/passenger/editPassenger',
      isCreate: true,
    },
    {
      icon: 'taxiAttendant',
      label: 'Begleitperson anlegen',
      route: '/taxiAttendant/addTaxiAttendant',
      isCreate: true,
    },
    {
      icon: 'phone',
      label: 'Fahrgast Account anlegen',
      route: '/appAccounts/editAppAccount',
      isCreate: true,
    },
    {
      icon: 'contacts',
      label: 'Kontakt anlegen',
      route: '/contacts/editContact',
      isCreate: true,
    },
  ];

  getPrimaryItems(): SidebarNavigationItem[] {
    return this.primaryItems;
  }

  getSecondaryItems(): SidebarNavigationItem[] {
    return this.secondaryItems;
  }

  getCommandPaletteItems(): SidebarNavigationItem[] {
    return [...this.primaryItems, ...this.secondaryItems, ...this.createItems];
  }
}
